import { PropertyTenantResolutionState } from './Types/PropertyTenantResolutionState';

import { PropertyTenantResolutionActions, PropertyTenantResolutionActionTypes } from './actions';
import { LoadStatus } from '../../Types';

export const initialState: PropertyTenantResolutionState = {
    currentPermissionContext: null,
    loadStatus: LoadStatus.INITIAL_STATE,
    loadingOccupants: false,
    sortOrder: [],
    propertiesWithOccupantsLoaded: [],
};

export function propertyTenantResolutionReducer(
    state: PropertyTenantResolutionState = initialState,
    action: PropertyTenantResolutionActionTypes,
): PropertyTenantResolutionState {
    switch (action.type) {
        case PropertyTenantResolutionActions.LOAD_PROPERTY_TENANT_LIST:
            return {
                ...state,
                currentPermissionContext: action.payload.permission,
                loadStatus: LoadStatus.PENDING,
            };
        case PropertyTenantResolutionActions.LOAD_PROPERTY_OCCUPANTS:
            return {
                ...state,
                loadingOccupants: true,
            };
        case PropertyTenantResolutionActions.RESET_PROPERTY_TENANT_LIST:
            return {
                currentPermissionContext: null,
                loadStatus: LoadStatus.INITIAL_STATE,
                loadingOccupants: false,
                sortOrder: [],
                propertiesWithOccupantsLoaded: [],
            };
        case PropertyTenantResolutionActions.SET_PROPERTY_TENANT_LIST:
            return {
                ...state,
                loadStatus: LoadStatus.LOADED,
                ...action.payload.properties.reduce(
                    (agg, curr) => ({
                        ...agg,
                        [curr.id]: curr,
                    }),
                    {},
                ),
                sortOrder: action.payload.properties.map((p) => p.id),
                propertiesWithOccupantsLoaded: [],
            };
        case PropertyTenantResolutionActions.FILL_PROPERTY_OCCUPANTS:
            return {
                ...state,
                loadingOccupants: false,
                [action.payload.propertyId]: {
                    ...state[action.payload.propertyId],
                    occupants: [...action.payload.occupants],
                },
                propertiesWithOccupantsLoaded: [...state.propertiesWithOccupantsLoaded, action.payload.propertyId],
            };
        default:
            return state;
    }
}
